import Navbar from "./Components/Navbar/navbar";
import Sidebar from "./Components/Navbar/Sidebar";
import { Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import Home from "./Components/Home/home";
import CarePlans from "./Components/CarePlans/carePlans";
import Services from "./Components/Services/Services";
import Footer from "./Components/Footer/Footer";
import Careers from "./Components/Careers/careers";
import Testimonials from "./Components/Testimonials/testimonials";
import Privacy from "./Components/legal/privacy";
import Terms from "./Components/legal/terms";
import QueryForms from "./Components/legal/queryforms";
import Christmas from "./Components/Christmas/Christmas";
import ChatbotModal from "./Components/ChatbotModal/ChatbotModal";
import Guarantee from "./Components/Guarantee/Guarantee";
import WhatWeDo from "./Components/WhatWeDo/WhatWeDo";
import Pricing from "./Components/Pricing/Pricing";
import Contact from "./Components/Contact/Contact";
import OurStory from "./Components/OurStory/OurStory";
import HowItWorks from "./Components/HowItWorks/HowItWorks";
import "./styles/home.css";

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isMobile;
}

function App() {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const isMobile = useIsMobile();

  const handleScheduleClick = (e) => {
    e.preventDefault(); // Prevent default link behavior
    setIsChatbotOpen(true);
  };

  return (
    <div className="App">
      <Navbar
        {...(isMobile ? { onSidebarOpen: () => setIsSidebarOpen(true) } : {})}
      />
      {isMobile && (
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <Routes>
        <Route
          exact
          path="/"
          element={<Home handleScheduleClick={handleScheduleClick} />}
        />
        <Route
          exact
          path="/care-plans"
          element={<CarePlans handleScheduleClick={handleScheduleClick} />}
        />
        <Route
          exact
          path="/services"
          element={<Services handleScheduleClick={handleScheduleClick} />}
        />
        <Route exact path="/careers" element={<Careers />} />
        <Route exact path="/testimonials" element={<Testimonials />} />
        <Route exact path="/privacy-policy" element={<Privacy />} />
        <Route exact path="/terms-conditions" element={<Terms />} />
        <Route exact path="/form" element={<QueryForms />} />
        <Route
          exact
          path="/guarantee"
          element={<Guarantee handleScheduleClick={handleScheduleClick} />}
        />
        <Route
          exact
          path="/what-we-do"
          element={<WhatWeDo handleScheduleClick={handleScheduleClick} />}
        />
        <Route
          exact
          path="/pricing"
          element={<Pricing handleScheduleClick={handleScheduleClick} />}
        />
        <Route
          exact
          path="/our-story"
          element={<OurStory handleScheduleClick={handleScheduleClick} />}
        />
        <Route
          exact
          path="/how-it-works"
          element={<HowItWorks handleScheduleClick={handleScheduleClick} />}
        />

        <Route
          exact
          path="/contact"
          element={<Contact handleScheduleClick={handleScheduleClick} />}
        />
        <Route
          exact
          path="/christmas"
          element={<Christmas handleScheduleClick={handleScheduleClick} />}
        />
      </Routes>
      <Footer />

      <ChatbotModal
        isOpen={isChatbotOpen}
        onClose={() => setIsChatbotOpen(false)}
      />

      <zapier-interfaces-chatbot-embed
        is-popup="true"
        chatbot-id="clyi737ft0018463a0e3sn3cq"
      ></zapier-interfaces-chatbot-embed>
      {/* <script
      
        async
        type="module"
        src="https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js"
      ></script>
      <zapier-interfaces-chatbot-embed
        is-popup="true"
        chatbot-id="clyi737ft0018463a0e3sn3cq"
        height="600px"
        width="400px"
      ></zapier-interfaces-chatbot-embed> */}
    </div>
  );
}

export default App;
